/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/

import * as mainStyles from '../../../styles/layout/main.module.scss';
import PropTypes from 'prop-types';
import FilAriane from '../../page_structure/FilAriane';
import React from 'react';
import Title from '../../shared/Title';

const EventGuideLayout = ({ children, ...props }) => {
  const filAriane = [...props.filAriane];
  /* props.filAriane.shift(); */

  /*
  SDU
  _.remove(filAriane, function(n) {
    return n.target_object ? true : false;
  })
*/

  let displayLang = '';
  if (props && props.lang) {
    displayLang = props.lang.toLowerCase();
  }

  return (
    <div className={mainStyles.rootLayoutEvent}>
      <div
        className={mainStyles.innerInternalPage}
        id="main-content-page"
        style={{ backgroundColor: 'var(--white-color)' }}
      >
        <div
          className={mainStyles.innerTemplateFilArianeWithoutPage}
          style={{ paddingBottom: 20 }}
        >
          <FilAriane
            ariane={filAriane}
            lang={displayLang}
            url={props.url}
          >
          </FilAriane>
        </div>
        <div className={mainStyles.contentLayoutEvent}>
          <div style={{ marginBottom: 20 }}>
            <Title label={props.title}
              separator
              size={50}
            >
            </Title>
          </div>
          {props.header?.props?.carrousel && (
            <div
              className={mainStyles.innerInternalPageBlocHeaderCarrousel}
            >
              <div className={mainStyles.innerInternalPageElemHeader}>
                {props.header}
              </div>
            </div>
          )}
        </div>
        <div className={mainStyles.innerTemplateEvent}>{children}</div>
      </div>
    </div>
  );
};

EventGuideLayout.propTypes = {
  children: PropTypes.node,
  filAriane: PropTypes.arrayOf(PropTypes.shape({
    target_object: PropTypes.any,
  })).isRequired,
  header: PropTypes.shape({
    props: PropTypes.shape({
      carrousel: PropTypes.bool,
    }),
  }),
  lang: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default EventGuideLayout;
